import React, { useState } from 'react';

const SelectTrailerLocation = ({ fetchReports, allTrailers, theme }) => {
    const [error, setError] = useState('');
    const [trailer, setTrailer] = useState('');

    const isLightTheme = theme === 'light';

    // allTrailers is already filtered to only include trailers from the home page fetch function
    const trailers = allTrailers || [];

    // Handle form submission
    const handleSubmit = () => {
        if (!trailer) {
            setError('Please select a trailer!');
            return;
        }
        setError('');
        const reportData = {
            id: trailer,
        };
        fetchReports(reportData);
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap:10,
            justifyContent: 'center',
            alignItems: 'center', // Ensures vertical centering
            margin: '20px auto', // Centers the div horizontally
            padding: '40px',
            width: '100%', // Adjusts width to fit content
            border: '2px solid',
            borderRadius: '10px',
            minHeight: '290px', // Ensures a minimum height
        }}>
            
            <h2>Find Trailer</h2>

            {/* Select dropdown for trailer */}
            <select
                value={trailer}
                onChange={(e) => setTrailer(e.target.value)}
                style={{ 
                    padding: '5px', 
                    textAlign: 'center',
                    backgroundColor: isLightTheme ? '#fff' : '#333',
                    color: isLightTheme ? '#333' : '#fff',
                    border: `1px solid ${isLightTheme ? '#ccc' : '#555'}`,
                    borderRadius: '3px',
                    width: '100%'
                }}
            >
                <option value="">Trailer To Locate</option>
                {trailers.map((trailerObj) => (
                    <option key={trailerObj.id} value={trailerObj.id}>
                        {trailerObj.reg}
                    </option>
                ))}
            </select>

            {trailers.length === 0 && (
                <p style={{ color: isLightTheme ? '#ff6b6b' : '#ff8e8e', fontStyle: 'italic' }}>
                    {!allTrailers ? 'Loading trailers...' : 'No trailers found in the system.'}
                </p>
            )}

            {/* Submit button */}
            <button
                className="hoverable"
                onClick={handleSubmit}
                disabled={trailers.length === 0}
                style={{
                    padding: '5px 10px',
                    width: '100%',
                    backgroundColor: trailers.length === 0 ? '#6c757d' : '#007bff',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: trailers.length === 0 ? 'not-allowed' : 'pointer',
                }}
            >
                Find Last Location
            </button>

            {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
        </div>
    );
};

export default SelectTrailerLocation;